/**
 * @generated SignedSource<<958be17da254609546d9ce1de7c1bed0>>
 * @relayHash 71c72ee296b865f7611c2d46c4762a40
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 026d1b6978b4464e58068a382df83c4e7d8385a9f7ad9377edbd4d23c193c05f

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CatchupContentType = "BLOGPOST" | "PAGE" | "%future added value";
export type ViewPagePersonalizationQuery$variables = {
  catchupContentType: CatchupContentType;
  cloudId: string;
  contentId: string;
  includeAIFloatingContextMenu?: boolean | null;
  includeLoom?: boolean | null;
  includeMeetingRecorderEligibility: boolean;
  includeOmnibarOnboardingState?: boolean | null;
  includeOnboardingState?: boolean | null;
  includePresenceSettings?: boolean | null;
  includeRecommendations?: boolean | null;
  omnibarOnboardingKeys?: ReadonlyArray<string | null> | null;
  onboardingKeys?: ReadonlyArray<string | null> | null;
  recommendationEntityType: string;
  recommendationExperience: string;
  recommendationSpaceId: string;
  spaceKey: string;
};
export type ViewPagePersonalizationQuery$data = {
  readonly catchupGetLastViewedTime?: {
    readonly " $fragmentSpreads": FragmentRefs<"useDynamicSplitButton_catchupLastViewedTime">;
  } | null;
  readonly confluence_teamPresenceContentSetting?: {
    readonly " $fragmentSpreads": FragmentRefs<"ContentHeaderPresence_contentSetting">;
  } | null;
  readonly getRecommendedPages?: {
    readonly " $fragmentSpreads": FragmentRefs<"EndOfPageRecommendation_recommendedPages">;
  } | null;
  readonly getRecommendedPagesSpaceStatus?: {
    readonly " $fragmentSpreads": FragmentRefs<"EndOfPageRecommendation_spaceStatus">;
  } | null;
  readonly loom?: {
    readonly " $fragmentSpreads": FragmentRefs<"loomPersonalization_entryPoints" | "loomPersonalization_tenant">;
  } | null;
  readonly omnibarOnboardingState?: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"onboardingState_state">;
  }> | null;
  readonly onboardingState?: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"onboardingState_state">;
  }> | null;
  readonly space?: {
    readonly id: string | null;
  } | null;
};
export type ViewPagePersonalizationQuery = {
  response: ViewPagePersonalizationQuery$data;
  variables: ViewPagePersonalizationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "catchupContentType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAIFloatingContextMenu"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeLoom"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeMeetingRecorderEligibility"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeOmnibarOnboardingState"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeOnboardingState"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePresenceSettings"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRecommendations"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "omnibarOnboardingKeys"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "onboardingKeys"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recommendationEntityType"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recommendationExperience"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recommendationSpaceId"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v16 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v17 = {
  "args": [
    (v16/*: any*/)
  ],
  "concreteType": "ConfluenceLoomEntryPoints",
  "kind": "LinkedField",
  "name": "confluence_loomEntryPoints",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isLoomEntryPointsEnabled"
    }
  ]
},
v18 = [
  {
    "kind": "Variable",
    "name": "siteId",
    "variableName": "cloudId"
  }
],
v19 = {
  "condition": "includeMeetingRecorderEligibility",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": (v18/*: any*/),
      "concreteType": "LoomSettings",
      "kind": "LinkedField",
      "name": "loom_settings",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "meetingRecordingsAvailable"
        },
        {
          "kind": "ScalarField",
          "name": "meetingNotesEligible"
        }
      ]
    },
    {
      "args": (v18/*: any*/),
      "concreteType": "LoomConnectedCalendar",
      "kind": "LinkedField",
      "name": "loom_connectedCalendars",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "guid"
        }
      ]
    }
  ]
},
v20 = {
  "concreteType": "ConfluenceTenantContext",
  "kind": "LinkedField",
  "name": "confluence_tenantContext",
  "plural": false,
  "selections": [
    {
      "concreteType": "LicensedProduct",
      "kind": "LinkedField",
      "name": "licensedProducts",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "licenseStatus"
        },
        {
          "kind": "ScalarField",
          "name": "productKey"
        }
      ]
    }
  ]
},
v21 = {
  "kind": "ScalarField",
  "name": "id"
},
v22 = {
  "args": [
    {
      "kind": "Variable",
      "name": "key",
      "variableName": "spaceKey"
    }
  ],
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v21/*: any*/)
  ]
},
v23 = [
  {
    "kind": "Variable",
    "name": "entityId",
    "variableName": "contentId"
  },
  {
    "kind": "Variable",
    "name": "entityType",
    "variableName": "recommendationEntityType"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "recommendationExperience"
  }
],
v24 = [
  {
    "kind": "Variable",
    "name": "entityId",
    "variableName": "recommendationSpaceId"
  }
],
v25 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "onboardingKeys"
  }
],
v26 = [
  {
    "kind": "FragmentSpread",
    "name": "onboardingState_state"
  }
],
v27 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "omnibarOnboardingKeys"
  }
],
v28 = [
  {
    "kind": "Variable",
    "name": "contentId",
    "variableName": "contentId"
  },
  {
    "kind": "Variable",
    "name": "contentType",
    "variableName": "catchupContentType"
  }
],
v29 = [
  (v16/*: any*/),
  {
    "kind": "Variable",
    "name": "spaceKey",
    "variableName": "spaceKey"
  }
],
v30 = {
  "kind": "ScalarField",
  "name": "key"
},
v31 = {
  "kind": "ScalarField",
  "name": "value"
},
v32 = [
  (v30/*: any*/),
  (v31/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ViewPagePersonalizationQuery",
    "selections": [
      {
        "condition": "includeLoom",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "loomPersonalization_entryPoints",
                  "selections": [
                    (v17/*: any*/),
                    (v19/*: any*/)
                  ],
                  "argumentDefinitions": [
                    {
                      "kind": "RootArgument",
                      "name": "cloudId"
                    },
                    {
                      "kind": "RootArgument",
                      "name": "includeMeetingRecorderEligibility"
                    }
                  ]
                },
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "loomPersonalization_tenant",
                  "selections": [
                    (v20/*: any*/)
                  ],
                  "argumentDefinitions": []
                }
              ]
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "loom"
          }
        ]
      },
      {
        "condition": "includeRecommendations",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v22/*: any*/),
          {
            "args": (v23/*: any*/),
            "concreteType": "RecommendedPages",
            "kind": "LinkedField",
            "name": "getRecommendedPages",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "EndOfPageRecommendation_recommendedPages"
              }
            ]
          },
          {
            "args": (v24/*: any*/),
            "concreteType": "RecommendedPagesSpaceStatus",
            "kind": "LinkedField",
            "name": "getRecommendedPagesSpaceStatus",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "EndOfPageRecommendation_spaceStatus"
              }
            ]
          }
        ]
      },
      {
        "condition": "includeOnboardingState",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v25/*: any*/),
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": (v26/*: any*/)
          }
        ]
      },
      {
        "condition": "includeOmnibarOnboardingState",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "omnibarOnboardingState",
            "args": (v27/*: any*/),
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": (v26/*: any*/)
          }
        ]
      },
      {
        "condition": "includeAIFloatingContextMenu",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v28/*: any*/),
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "useDynamicSplitButton_catchupLastViewedTime"
              }
            ]
          }
        ]
      },
      {
        "condition": "includePresenceSettings",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v29/*: any*/),
            "concreteType": "ConfluenceTeamPresence",
            "kind": "LinkedField",
            "name": "confluence_teamPresenceContentSetting",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ContentHeaderPresence_contentSetting"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v15/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v8/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "ViewPagePersonalizationQuery",
    "selections": [
      {
        "condition": "includeLoom",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v17/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/)
        ]
      },
      {
        "condition": "includeRecommendations",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v22/*: any*/),
          {
            "args": (v23/*: any*/),
            "concreteType": "RecommendedPages",
            "kind": "LinkedField",
            "name": "getRecommendedPages",
            "plural": false,
            "selections": [
              {
                "concreteType": "RecommendedPagesItem",
                "kind": "LinkedField",
                "name": "recommendedPages",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "title"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "subType"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "creatorId"
                      },
                      {
                        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "webui"
                          }
                        ]
                      },
                      {
                        "concreteType": "History",
                        "kind": "LinkedField",
                        "name": "history",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "ownedBy",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v30/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          }
                        ]
                      },
                      {
                        "alias": "emoji",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "key",
                            "value": "emoji-title-published"
                          }
                        ],
                        "concreteType": "PaginatedJsonContentPropertyList",
                        "kind": "LinkedField",
                        "name": "properties",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              (v21/*: any*/),
                              (v30/*: any*/),
                              (v31/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": "properties(key:\"emoji-title-published\")"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "strategy"
                  }
                ]
              }
            ]
          },
          {
            "args": (v24/*: any*/),
            "concreteType": "RecommendedPagesSpaceStatus",
            "kind": "LinkedField",
            "name": "getRecommendedPagesSpaceStatus",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "recommendedPagesEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "defaultBehavior"
              }
            ]
          }
        ]
      },
      {
        "condition": "includeOnboardingState",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v25/*: any*/),
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": (v32/*: any*/)
          }
        ]
      },
      {
        "condition": "includeOmnibarOnboardingState",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "omnibarOnboardingState",
            "args": (v27/*: any*/),
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": (v32/*: any*/)
          }
        ]
      },
      {
        "condition": "includeAIFloatingContextMenu",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v28/*: any*/),
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "lastViewedTimeISO"
              }
            ]
          }
        ]
      },
      {
        "condition": "includePresenceSettings",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v29/*: any*/),
            "concreteType": "ConfluenceTeamPresence",
            "kind": "LinkedField",
            "name": "confluence_teamPresenceContentSetting",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isEnabledOnContentView"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "71c72ee296b865f7611c2d46c4762a40",
    "id": "026d1b6978b4464e58068a382df83c4e7d8385a9f7ad9377edbd4d23c193c05f",
    "metadata": {},
    "name": "ViewPagePersonalizationQuery",
    "operationKind": "query",
    "text": "query ViewPagePersonalizationQuery($contentId:ID!,$spaceKey:String!,$cloudId:ID!,$catchupContentType:CatchupContentType!,$recommendationEntityType:String!,$recommendationExperience:String!,$recommendationSpaceId:ID!,$onboardingKeys:[String],$omnibarOnboardingKeys:[String],$includeRecommendations:Boolean=false,$includeOnboardingState:Boolean=false,$includeOmnibarOnboardingState:Boolean=false,$includeAIFloatingContextMenu:Boolean=false,$includePresenceSettings:Boolean=false,$includeLoom:Boolean=false,$includeMeetingRecorderEligibility:Boolean!){...loomPersonalization_entryPoints@include(if:$includeLoom)\n  ...loomPersonalization_tenant@include(if:$includeLoom),space(key:$spaceKey)@include(if:$includeRecommendations){id}\n  getRecommendedPages(entityType:$recommendationEntityType,entityId:$contentId,experience:$recommendationExperience)@include(if:$includeRecommendations){...EndOfPageRecommendation_recommendedPages}\n  getRecommendedPagesSpaceStatus(entityId:$recommendationSpaceId)@include(if:$includeRecommendations){...EndOfPageRecommendation_spaceStatus},onboardingState(key:$onboardingKeys)@include(if:$includeOnboardingState){...onboardingState_state},omnibarOnboardingState:onboardingState(key:$omnibarOnboardingKeys)@include(if:$includeOmnibarOnboardingState){...onboardingState_state},catchupGetLastViewedTime(contentId:$contentId,contentType:$catchupContentType)@include(if:$includeAIFloatingContextMenu){...useDynamicSplitButton_catchupLastViewedTime},confluence_teamPresenceContentSetting(cloudId:$cloudId,spaceKey:$spaceKey)@include(if:$includePresenceSettings){...ContentHeaderPresence_contentSetting}}fragment ContentHeaderPresence_contentSetting on ConfluenceTeamPresence{isEnabledOnContentView}fragment EndOfPageRecommendation_recommendedPages on RecommendedPages{recommendedPages{content{id,title,type,subType,creatorId,links{webui},history{ownedBy{__typename,displayName}},space{id,key,name},emoji:properties(key:\"emoji-title-published\"){nodes{id,key,value}}},strategy}}fragment EndOfPageRecommendation_spaceStatus on RecommendedPagesSpaceStatus{recommendedPagesEnabled,defaultBehavior}fragment loomPersonalization_entryPoints on Query{confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled},loom_settings(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){meetingRecordingsAvailable,meetingNotesEligible}\n  loom_connectedCalendars(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){guid}}fragment loomPersonalization_tenant on Query{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}fragment onboardingState_state on OnboardingState{key,value}fragment useDynamicSplitButton_catchupLastViewedTime on CatchupLastViewedTimeResponse{lastViewedTimeISO}"
  }
};
})();

(node as any).hash = "b4f9a44858f90cfe9ba62bcb3bdc2d25";

export default node;
